
import './App.scss';
import img1 from './img/1.png'
import img2 from './img/2.png'
import icon1 from './img/icon1.png'
import icon2 from './img/icon2.png'
import er from './img/er.png'
import icon3 from './img/icon3.png'
import { getKuaiXun, getTopNews, getRank, getinfo } from './api/getkuaixun';
import { useEffect, useState } from 'react';
import SwiperComponent from './Swiper'
const Rank = (props) => {
  console.log('-----------')
  console.log(props.rank)
  console.log('-----------')
  if (!props.rank) {
    return ''
  } else {

    return (

      <div className='g-rank'>
        <div className='m-rank-title'>
          <div className='u-rank-icon'>
            <img src={icon1} className='u-icon1' />
            今日牛人榜
          </div>
          交易时段实时更新
        </div>


        <div className='m-rank-content'>
          {props.rank.map((item, index) => (
            <div className='u-rank-item' key={index}>
              <div className='u-rank-avatar'>
                <img src={item.headPic || 'https://static.nbd.com.cn/images/journalist_h_2.png'} />
                <div className='u-rank-tag'>
                  收益率排名{item.rank}
                </div>
              </div>
              <p className='u-num'>{(item.yield * 100).toFixed(2)}%</p>
              <a href='https://www.nbd.com.cn/corp/2016app/index.html' className='u-look'>
                看持仓
              </a>
            </div>
          ))}

        </div>






      </div>

    )

  }
}



function App() {
  const [newsList, setNewsList] = useState(() => {
    getKuaiXun().then(res => {
      // console.log(res.data.list)
      setNewsList(res.data.list)
    })
  })
  const [topNews, setTopNews] = useState(() => {
    getTopNews().then(res => {
      console.log(res.data)
      // setTopNews([JSON.parse(JSON.stringify(res.top_articles['1'])), JSON.parse(JSON.stringify(res.top_articles['2'])),JSON.parse(JSON.stringify(res.top_articles['3']))]) 
      setTopNews([res.data.top_articles['1'], res.data.top_articles['2'], res.data.top_articles['3']])

    })
  })
  const [rank, setRank] = useState(() => {
    getRank().then(res => {

      if (res.data.length == 0) {
        setRank(undefined)
      } else {
        let first = res.data.shift()
        res.data.splice(1, 0, first)
        setRank(res.data)
      }


    })
  })

  const [info, setInfo] = useState(() => {
    getinfo().then(res => {

      setInfo(res.data)

    })
  })

  useEffect(() => {

    console.log(newsList)
  }, [newsList])
  useEffect(() => {

    console.log(topNews)
  }, [topNews])
  useEffect(() => {
    console.log(rank)

  }, [rank])
  useEffect(() => {
    console.log(info)

  }, [info])
  return (
    <div className="App">
      <header className="g-juejin-header">
        <div className='m-top-title'>
          <div className='m-top-box'>
            <div className='u-tag'>
              <i></i>
              <span> 比赛进行</span>
              ...
            </div>
          </div>
          <div className='m-tag'>正式赛</div>
        </div>
        <div className='m-match-info'>
          <p>报名时间：{info?.matchDetail.signupStartDate} ~ {info?.matchDetail.signupEndDate} </p>
          <p>比赛时间：{info?.matchDetail.matchStartDate} ~ {info?.matchDetail.matchEndDate} </p>
          <p>模拟资金：20万元</p>
        </div>
        <div className='m-srcoll-text swiper-no-swiping'>
          <SwiperComponent index={0} carouselInfo={newsList?.slice(0, 45)} />
          <SwiperComponent index={1} carouselInfo={newsList?.slice(45)} />
        </div>
        <div className='m-news-list'>
          {/* <ul>
            {
              topNews?.map((item, index) => {
                return (
                  <li key={'http://www.nbd.com.cn/corp/newArticle/index.html#/app_article/' + item.id}>
                    <a href={'http://www.nbd.com.cn/corp/newArticle/index.html#/app_article/' + item.id}>
                      <span>热</span>
                      {item.title}
                    </a>
                  </li>

                )
              })
            }
          </ul> */}
          <div className='m-news-new-title'>
            <span>参赛路径</span>
            下载每日经济新闻APP-私人定制-掘金大赛
          </div>
          <p className='m-news-new-hint'>想要关注市场最新资讯、学习高手投资风格，立即加入比赛交流群⬇⬇</p>
          <img src={er} className='u-er' />
        </div>



      </header>
      <img src={img1} className='m-img' />
      <img src={img2} className='m-img' />
      {/* <Rank rank={rank} /> */}

      <a href='http://www.nbd.com.cn/corp/2016app/'>
        <img src={icon2} className='u-icon2' />
      </a>
      <img src={icon3} className='u-icon3' />
    </div>
  );
}

export default App;
